import React from 'react';
import { Container, Navbar } from '@themesberg/react-bootstrap';
import ListCiem from "../../components/Ciem/ListCiem";


const ListCiemPage = () => {
    return (
        <>
            {/* Navbar */}
            <Navbar bg="dark" variant="dark" className="mb-4">
                <Container>
                    <Navbar.Brand>Bienvenidos a la creacion de ideas de negocio</Navbar.Brand>
                </Container>
            </Navbar>

            {/* Contenido de la página */}
            <Container>
                <h1 className="text-center my-4">Listado de ideas de negocio</h1>
                <ListCiem />
            </Container>
        </>
    );
};

export default ListCiemPage;